export const initStickyElements = () => {
    const visibleComponent = document.querySelector('.component-scroll-wrapper');

    if (visibleComponent) {
        const visibleContentVisibleHeight = visibleComponent.offsetHeight,
            stickyElements = visibleComponent.querySelectorAll('[data-element="sticky-block"]');



        const wWithOutScrollbar = visibleComponent.clientWidth,
            wWithScrollbar = visibleComponent.offsetWidth,
            scrollbarW = wWithScrollbar - wWithOutScrollbar,
            scrollbarOffset = scrollbarW / 2;

        if (stickyElements) {
            stickyElements.forEach((stickyElement) => {
                const stickyElementCordsRelativeFullWindowHeight = stickyElement.getBoundingClientRect().top + 20,
                    stickyElementHeight = stickyElement.clientHeight,
                    isElementVisible = stickyElementCordsRelativeFullWindowHeight >= visibleContentVisibleHeight ? 'false' : 'true',
                    hasOrientir = stickyElement.getAttribute('data-element-id-with-cord')

                console.log(visibleContentVisibleHeight);

                stickyElement.setAttribute('data-is-visible', isElementVisible);
                stickyElement.setAttribute('data-is-init', 'true');

                if (isElementVisible) {
                    stickyElement.style.marginLeft = `-${scrollbarOffset}px`
                } else {
                    stickyElement.style.marginLeft = `0px`
                }

                if (!hasOrientir) {
                    let elementId = new Date().getTime(),
                        styleHeight = stickyElementHeight

                    if (isElementVisible) {
                        styleHeight = 1
                    }

                    stickyElement.insertAdjacentHTML('beforebegin', `<div class="orient-block" id="el_${elementId}" data-height="${stickyElementHeight}" style="height: ${styleHeight}px" >`);
                    stickyElement.setAttribute('data-element-id-with-cord', +elementId);
                }
            });

            const stickyHandler = () => {
                const scrolledPixels = visibleComponent.scrollTop,
                    positionForVisibleSticky = visibleComponent.offsetHeight + visibleComponent.scrollTop,
                    stickyElements = visibleComponent.querySelectorAll('[data-element="sticky-block"][data-is-init="true"]')

                stickyElements.forEach((stickyElement) => {
                    const elementWithCordId = stickyElement.getAttribute('data-element-id-with-cord'),
                        elementWithCord = visibleComponent.querySelector(`#el_${elementWithCordId}`),
                        stickyElementCordsRelativeFullWindowHeight = elementWithCord.getBoundingClientRect().top + 20,
                        isElementVisible = Math.floor(stickyElementCordsRelativeFullWindowHeight + visibleComponent.scrollTop) > Math.floor(visibleComponent.offsetHeight + visibleComponent.scrollTop) ? 'false' : 'true'


                    stickyElement.setAttribute('data-is-visible', isElementVisible);

                    if (isElementVisible === 'true') {
                        elementWithCord.style.height = '1px';
                        stickyElement.style.marginLeft = `0px`
                    } else {
                        const h = elementWithCord.getAttribute('data-height')
                        elementWithCord.style.height = `${h}px`;

                        stickyElement.style.marginLeft = `-${scrollbarOffset}px`
                    }
                })
            }

            visibleComponent.addEventListener('scroll', stickyHandler);
            window.addEventListener('resize', stickyHandler);
        }
    }
}
